<div [hidden]="!isLoading" class="page-loader text-center">
    <div class="loader"></div>
</div>

@if (pages$ | async) {
    <div class="row">
        <div class="col-sm-12 search-results-content px-0">
            <core-client-search-form [autoFocus]="!hasSearchTerm()"></core-client-search-form>

            <div class="row search-top">
                @if ((!hasResults() && hasSearchTerm()) || (hasResults() && introText)) {
                    <div class="col-sm-12">
                        @if (!hasResults() && hasSearchTerm() && search.isActive() && !isLoading) {
                            <p [innerHTML]="noResultsText"></p>
                        }
                        @if (hasResults() && introText) {
                            <p [innerHTML]="introText"></p>
                        }
                    </div>
                }
            </div>

            <div class="search-results__tabs">
                <core-block-faq [faq$]="faq$" />

                @if (hasResults()) {
                    @if (!isLoading) {
                        <p class="w-100 text-end">
                            Displaying <strong [innerText]="getDisplayCount()"></strong> of
                            <strong [innerText]="total"></strong>&nbsp;results
                        </p>
                    }

                    <div
                        (scrolled)="onScroll()"
                        [infiniteScrollDistance]="distance"
                        [infiniteScrollThrottle]="throttle"
                        class="g-4 row row-cols-1 row-cols-sm-2 row-cols-md-3"
                        infinite-scroll>
                        @for (card of results; track trackByFn($index, card)) {
                            <div class="col">
                                <core-client-block-card
                                    [cardType]="card.type ?? ''"
                                    [card]="card"
                                    [displayTags]="true"
                                    [parentUrl]="parentUrl(card)"
                                    [zone]="currentZone"></core-client-block-card>
                            </div>
                        }

                        @if (isLoading) {
                            @for (shimmer of getShimmerCards(); track shimmer) {
                                <div class="col">
                                    <core-block-card-shimmer></core-block-card-shimmer>
                                </div>
                            }
                        }
                    </div>

                    @if (hasMoreContent()) {
                        <button
                            (click)="loadMore()"
                            [innerText]="loadMoreText"
                            class="btn btn-secondary d-block mx-auto mt-3"></button>
                    }
                }
            </div>
        </div>
    </div>
}
